// extracted by mini-css-extract-plugin
module.exports = {"detail-button__wrapper":"detail-button__wrapper","detail-button__text":"detail-button__text"};